<template>
    <div class="report-model">
        <div class="report-content">
            <div class="report-title">
                <span>举报反馈</span>
                <span class="el-icon-close" @click="close()" />
            </div>
            <div class="report-list">
                <div class="report-tips">小囊会尽快受理你的举报，请尽量补充完整描述</div>
                <div class="report-label">请选择投诉文章的原因</div>
                <div class="report-tags">
                    <div
                        class="report-tag"
                        :class="{'tag-50': item.type === 6,
                        'tag-active': reportModel.type === item.type}"
                        v-for="item in reportTypeList"
                        :key="'reportType' + item.type"
                        @click="handleReportType(item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <div class="report-label">补充说明</div>
                <div class="report-input">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="reportModel.content"
                        maxlength="100"
                        rows="4"
                        show-word-limit
                    />
                </div>
                <div class="report-tips">你可以上传相关证据或设计举报内容具体位置的图片，帮助小囊更快的核实处理</div>
                <div class="report-upload">
                    <el-upload
                        :action="uploadMinioUrl"
                        :headers="uploadHeaders"
                        :on-success="handleUploadSuccess"
                        class="upload-card"
                        list-type="picture-card"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemove"
                        :limit="4"
                        :on-exceed="handleExceed"
                        :file-list="fileList"
                    >
                        <div v-if="fileList.length < 4">
                            <span class="el-icon-plus" />
                        </div>
                        <div>{{ fileList.length }}/4</div>
                    </el-upload>
                </div>
                <div class="report-footer">
                    <span @click="close()">取消</span>
                    <span @click="submit()">确定举报</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {insertReport, uploadMinioUrl} from '@/api'
import { getToken } from "@/utils/auth";
export default {
    data() {
        return {
            uploadMinioUrl,
            uploadHeaders: {
                Authorization: 'Bearer ' + getToken()
            },
            reportModel: {
                type: null,
                content: '',
                imgUrl1: '',
                imgUrl2: '',
                imgUrl3: '',
                imgUrl4: ''
            },
            reportTypeList: [
                {type: 1, name: '低俗色情'},
                {type: 2, name: '内容抄袭'},
                {type: 3, name: '涉嫌违法'},
                {type: 4, name: '恶意营销'},
                {type: 5, name: '内容质量太差'},
                {type: 6, name: '侵犯名誉/隐私/肖像权等'},
                {type: 7, name: '其他原因'}
            ],
            fileList: []
        }
    },
    props: {
        targetId: {
            type: Number,
            default: null
        }
    },
    methods: {
        handleReportType(item) {
            this.reportModel.type = item.type
        },
        // 关闭弹框
        close() {
            this.$emit('close');
        },
        beforeUpload(file) {
            const isImage = file.type.startsWith('image/');
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isImage) {
                this.$message.error('只能上传图片文件！');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('图片大小不能超过 10MB！');
                return false;
            }
            return true;
        },
        handleUploadSuccess(response, file) {
            this.fileList.push(file)
        },
        handleRemove(file, fileList) {
            this.fileList = fileList;
        },
        handleExceed() {
            this.$message.warning('最多只能上传4张图片！')
        },
        // 提交举报信息
        submit() {
            if(this.reportModel.type === null) {
                return this.$message.warning('请选择投诉文章的原因')
            }
            if(this.reportModel.content === '') {
                return this.$message.warning('请填写补充说明')
            }
            insertReport({
                type: this.reportModel.type,
                targetType: 6,
                targetId: this.$props.targetId,
                content: this.reportModel.content,
                imgUrl1: this.fileList[0]?.response?.url,
                imgUrl2: this.fileList[1]?.response?.url,
                imgUrl3: this.fileList[2]?.response?.url,
                imgUrl4: this.fileList[3]?.response?.url
            })
                .then((res) => {
                    this.$message.success('提交举报成功')
                    this.$emit('reportSuccess');
                })
                .catch(() => {
                    this.$message.error('提交举报失败')
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.report-model {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1001;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .report-content {
        position: absolute;
        z-index: 21;
        background-color: #FFFFFF;
        border-radius: 6px;
        width: 800px;
        .report-title {
            width: 100%;
            height: 40px;
            padding: 0 20px;
            font-size: 16px;
            border-bottom: 1px #e3e3e3 solid;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span:nth-child(2) {
                font-size: 20px;
                cursor: pointer;
            }
        }
        .report-list {
            width: 100%;
            padding: 21px;
            .report-tips {
                font-size: 14px;
                color: #888888;
            }
            .report-label {
                position: relative;
                width: 100%;
                padding: 20px 0px 10px 0px;
                font-size: 14px;
                color: #1a1a1a;
                &::before {
                    position: absolute;
                    left: -8px;
                    top: 12px;
                    content: '*';
                    color: red;
                }
            }
            .report-tags {
                width: 100%;
                margin-bottom: -10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                .report-tag {
                    width: calc(25% - 20px);
                    height: 55px;
                    margin-bottom: 10px;
                    background-color: rgb(242, 242, 242);
                    border-radius: 6px;
                    font-size: 14px;
                    color: #1a1a1a;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &:hover {
                        color: $color-primary;
                        background-color: rgba($color-primary, 0.15);
                    }
                    &.tag-active {
                        color: #FFFFFF;
                        background-color: $color-primary;
                    }
                }
                .tag-50 {
                    width: calc(50% - 12.5px);
                }
            }
            .report-input {
                width: 100%;
                padding-bottom: 10px;
                ::v-deep .el-textarea__inner:focus {
                    border-color: $color-primary;
                }
            }
            .report-upload {
                width: 100%;
                padding-top: 10px;
                &::v-deep(.el-upload) {
                    width: 90px;
                    height: 90px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;
                    flex-wrap: wrap;
                    div {
                        width: 100%;
                        line-height: 20px;
                        font-size: 14px;
                        color: #333333;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
            .report-footer {
                width: 100%;
                padding-top: 15px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                span {
                    width: 100px;
                    height: 32px;
                    font-size: 15px;
                    border-radius: 6px;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &:nth-child(1) {
                        border: 1px $color-primary solid;
                        color: $color-primary;
                        margin-right: 10px;
                    }
                    &:nth-child(2) {
                        border: 1px #FFFFFF solid;
                        color: #FFFFFF;
                        background-color: $color-primary;
                    }
                }
            }
        }
    }
}
</style>
